import React from 'react';
import { ColumnsType } from 'antd/es/table';
import { ReactComponent as Delete } from 'assets/icons/delete.svg';
import { ReactComponent as Edit } from 'assets/icons/draft.svg';
import { SupplierTableColumns } from 'enums/SupplierEnums';
import { ProcessingFacilityProps } from 'enums/ProcessingFacilityEnums';
import styles from './Suppliers.module.scss';
import clsx from 'clsx';
import stringComparator from 'shared/utils/stringComparator';
import { Address } from 'models/Address/address.model';

interface DataType {
  id: React.Key;
  supplier: string;
  name: string;
  address: Address;
}

type ColumnsProps = {
  handleOpenEditModal: () => void;
  handleOpenDeleteModal: () => void;
};

export const getColumns = ({
  handleOpenEditModal,
  handleOpenDeleteModal,
}: ColumnsProps): ColumnsType<DataType> => {
  return [
    {
      title: SupplierTableColumns.SUPPLIER_TITLE,
      dataIndex: SupplierTableColumns.SUPPLIER_INDEX,
      defaultSortOrder: SupplierTableColumns.SUPPLIER_SORT_ORDER,
      sorter: (a, b) => stringComparator(a.name, b.name)
    },
    {
      title: SupplierTableColumns.ADDRESS_TITLE,
      dataIndex: SupplierTableColumns.ADDRESS_INDEX,
      defaultSortOrder: SupplierTableColumns.ADDRESS_SORT_ORDER,
      render: (text, record) => {
        return `${record.address.street} ${record.address.province} ${record.address.country}`;
      },
      sorter: (a, b) => {
        const aAddress= `${a.address.street} ${a.address.province} ${a.address.country}`;
        const bAddress= `${b.address.street} ${b.address.province} ${b.address.country}`;
       
        return stringComparator(aAddress, bAddress)
        
      },
    },
    {
      title: SupplierTableColumns.ACTION_TITLE,
      dataIndex: SupplierTableColumns.ACTION_INDEX,
      width: SupplierTableColumns.ACTION_WIDTH,
      render: () => (
        <span className={styles.actionIconContainer}>
          <>
            <div
              className={clsx({
                [styles.rowIcon]: true,
                [styles.editIconContainer]: true,
              })}
              onClick={handleOpenEditModal}>
              <Edit
                type={ProcessingFacilityProps.EDIT_ICON_ALT}
                className={styles.editIcon}
              />
            </div>
            <div
              className={clsx({
                [styles.rowIcon]: true,
                [styles.editIconContainer]: true,
              })}
              onClick={handleOpenDeleteModal}>
              <Delete
                type={ProcessingFacilityProps.DELETE_ICON_ALT}
                className={styles.deleteIcon}
              />
            </div>
          </>
        </span>
      ),
    },
  ];
};
